export default __webpack_public_path__ + "static/media/integrations-visual-1.89fd0099.svg";